/**
 * This module prepares the paper rendering by creating a props object used in
 * layouts, choosing the right template and calling its render, wrapped in an
 * iddleCallback to avoid freezing the client on big computation (on font-size
 * for instance)
 * SEE controllers/templates/* for the various usable templates
 */

import Store from 'store/store'
import contrast from 'utils/color-contrast'
import domCMYK from 'utils/dom-cmyk-color'

// Load dynamically all templates/ modules
const TEMPLATES = {}
require.context('controllers/templates', true, /.(js)$/).keys().forEach(k => {
  const name = k.match(/\/(.+).js$/)[1]
  TEMPLATES[name] = require('controllers/templates/' + name + '.js').default
})

export default paper => new Promise(resolve => {
  const refs = {}
  const props = {}
  const template = paper.state.template.get()

  props.colorSpace = paper.state.colorSpace.get()
  props.colors = Store.landscape.colors.get()
  const background = props.colors.find(c => c.isBackground)

  // Using custom prefixed attribute to handle cmyk while SVG is in the DOM
  props.background = props.colorSpace === 'cmyk'
    ? domCMYK(background)
    : { fill: background.css }

  // Using named colors for the foreground, as colorSpace conversion is done during export
  props.foreground = contrast(background.rgb)

  props.bleed = paper.state.bleed.get()
  props.width = paper.props.format.dimensions[0]
  props.height = paper.props.format.dimensions[1]
  props.orientation = (props.width / props.height) > 1 ? 'landscape' : 'portrait'
  props.unit = Math.max(props.width, props.height) * 0.05
  props.padding = props.unit / 2
  props.hasLogos = !Store.poster.hasNoLogos.get() && paper.state.showLogos.get()
  props.bannerHeight = props.unit + props.padding * 2

  // Helper for quickly rendering a vnode and keeping track of its ref. We are
  // using here a different ref system than the utils/jsx one, because we need
  // to keep track of some ref inside a template function in a more volatile way.
  // As the Paper component is not destroyed at each render, this avoids
  // destroying paper.ref
  const render = (ref, vnode) => {
    refs[ref] = paper.render(vnode, paper.refs.svg).components[0]
  }

  window.requestIdleCallback(() => {
    paper.clear()

    render('background', (
      <rect
        {...props.background}
        x={-props.bleed}
        y={-props.bleed}
        width={props.width + props.bleed * 2}
        height={props.height + props.bleed * 2}
      />
    ))

    TEMPLATES[template || 'default'](props, refs, paper, render).then(resolve)
  })
})



// WEBPACK FOOTER //
// ./src/controllers/templates/render.js